import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { DraftInvoiceSection } from '../../components/draft-invoice-section.component';
import { useTranslation } from 'react-i18next';


function HolidayPayReportPage() {
    const { t } = useTranslation();

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar />

                <div className="dashboard-main-content">
                    <Header
                    />
                    <div className='px-3'>
                        <div>
                            <h1 className="dashboard-page__title mb-0">{t('DRAFT')}</h1>
                        </div>
                        <DraftInvoiceSection
                            className="invoices-section"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default HolidayPayReportPage;
